"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _services = require("@/services");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t17 in e) "default" !== _t17 && {}.hasOwnProperty.call(e, _t17) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t17)) && (i.get || i.set) ? o(f, _t17, i) : f[_t17] = e[_t17]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  farmSelectedPaymentDetail: null
};
var mutations = _defineProperty({}, MutationTypes.SET_FARM_PAYMENT_DETAIL, function (state, farm) {
  state.farmSelectedPaymentDetail = farm;
});
var getters = {
  farmPaymentDetail: function farmPaymentDetail(state) {
    return state.farmSelectedPaymentDetail;
  }
};
var actions = {
  setPaymentFarm: function setPaymentFarm(_ref, payload) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    commit(MutationTypes.SET_FARM_PAYMENT_DETAIL, payload);
  },
  fetchPaymentInvoices: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2, id) {
      var commit, dispatch, _yield$paymentService, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref2.commit, dispatch = _ref2.dispatch;
            _context.p = 1;
            _context.n = 2;
            return _services.paymentService.fetchPaymentInvoices(id);
          case 2:
            _yield$paymentService = _context.v;
            data = _yield$paymentService.data;
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  fetchSubscriptionDetail: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4, id) {
      var commit, dispatch, _yield$paymentService2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref4.commit, dispatch = _ref4.dispatch;
            _context2.p = 1;
            _context2.n = 2;
            return _services.paymentService.fetchSubscriptionDetail(id);
          case 2:
            _yield$paymentService2 = _context2.v;
            data = _yield$paymentService2.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()),
  fetchFarmsPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref6) {
      var commit, dispatch, response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref6.commit, dispatch = _ref6.dispatch;
            _context3.p = 1;
            _context3.n = 2;
            return _services.paymentService.fetchFarms();
          case 2:
            response = _context3.v;
            return _context3.a(2, response);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }()),
  fetchFarmPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref8, farmId) {
      var commit, dispatch, response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref8.commit, dispatch = _ref8.dispatch;
            _context4.p = 1;
            _context4.n = 2;
            return _services.paymentService.fetchFarmPayment(farmId);
          case 2:
            response = _context4.v;
            return _context4.a(2, response);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x6, _x7) {
      return _ref9.apply(this, arguments);
    };
  }()),
  fetchPlansPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref0, farmId) {
      var commit, dispatch, _yield$paymentService3, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref0.commit, dispatch = _ref0.dispatch;
            _context5.p = 1;
            _context5.n = 2;
            return _services.paymentService.fetchPlansPayment({
              farmId: farmId
            });
          case 2:
            _yield$paymentService3 = _context5.v;
            data = _yield$paymentService3.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x8, _x9) {
      return _ref1.apply(this, arguments);
    };
  }()),
  fetchSubcribitionsPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref10) {
      var commit, dispatch, response, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref10.commit, dispatch = _ref10.dispatch;
            _context6.p = 1;
            _context6.n = 2;
            return _services.paymentService.getSubcribitions();
          case 2:
            response = _context6.v;
            return _context6.a(2, response);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x0) {
      return _ref11.apply(this, arguments);
    };
  }()),
  fetchRecurrentPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref12, recurrentId) {
      var commit, dispatch, _yield$paymentService4, data, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref12.commit, dispatch = _ref12.dispatch;
            _context7.p = 1;
            _context7.n = 2;
            return _services.paymentService.consultPaymentRecurrent(recurrentId);
          case 2:
            _yield$paymentService4 = _context7.v;
            data = _yield$paymentService4.data;
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref13.apply(this, arguments);
    };
  }()),
  consultCreditCardBin: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref14, payload) {
      var commit, dispatch, response, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref14.commit, dispatch = _ref14.dispatch;
            _context8.p = 1;
            _context8.n = 2;
            return _services.paymentService.consultCreditCardBin(payload);
          case 2:
            response = _context8.v;
            return _context8.a(2, response.data);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref15.apply(this, arguments);
    };
  }()),
  subscriptionPayment: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref16, payload) {
      var commit, dispatch, _yield$paymentService5, data, successMessage, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref16.commit, dispatch = _ref16.dispatch;
            _context9.p = 1;
            _context9.n = 2;
            return _services.paymentService.subscriptionPayment(payload);
          case 2:
            _yield$paymentService5 = _context9.v;
            data = _yield$paymentService5.data;
            successMessage = _router.default.app.$t('pages.payment.payment_create_success');
            _helpers.messageHelper.success(successMessage);
            return _context9.a(2, data);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref17.apply(this, arguments);
    };
  }()),
  consultTransationsOrderId: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref18, payload) {
      var commit, dispatch, params, _yield$paymentService6, data, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref18.commit, dispatch = _ref18.dispatch;
            _context0.p = 1;
            params = {
              orderId: payload
            };
            _context0.n = 2;
            return _services.paymentService.consultTransationsOrderID(params);
          case 2:
            _yield$paymentService6 = _context0.v;
            data = _yield$paymentService6.data;
            return _context0.a(2, data);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref19.apply(this, arguments);
    };
  }()),
  fetchAccountManagementData: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref20, params) {
      var commit, dispatch, _yield$paymentService7, data, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref20.commit, dispatch = _ref20.dispatch;
            _context1.p = 1;
            _context1.n = 2;
            return _services.paymentService.fetchAccountManagementData(params);
          case 2:
            _yield$paymentService7 = _context1.v;
            data = _yield$paymentService7.data;
            return _context1.a(2, data);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x17, _x18) {
      return _ref21.apply(this, arguments);
    };
  }()),
  blockFarm: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref22, id) {
      var commit, rootState, response, successMessage, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref22.commit, rootState = _ref22.rootState;
            _context10.p = 1;
            _context10.n = 2;
            return _services.paymentService.blockFarm({
              farmId: id
            });
          case 2:
            response = _context10.v;
            successMessage = _router.default.app.$t('pages.accountManagement.messages.block_success');
            _helpers.messageHelper.success(successMessage);
            return _context10.a(2, response);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x19, _x20) {
      return _ref23.apply(this, arguments);
    };
  }()),
  fetchZip: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref24, zip) {
      var commit, rootState, _yield$paymentService8, data, _t11;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref24.commit, rootState = _ref24.rootState;
            _context11.p = 1;
            _context11.n = 2;
            return _services.paymentService.fetchZip(zip);
          case 2:
            _yield$paymentService8 = _context11.v;
            data = _yield$paymentService8.data;
            return _context11.a(2, data);
          case 3:
            _context11.p = 3;
            _t11 = _context11.v;
            _helpers.errorResponseHelper.display(_t11);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    return function (_x21, _x22) {
      return _ref25.apply(this, arguments);
    };
  }()),
  changePaymentMethod: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref26, payload) {
      var commit, dispatch, _yield$paymentService9, data, successMessage, _t12;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref26.commit, dispatch = _ref26.dispatch;
            _context12.p = 1;
            _context12.n = 2;
            return _services.paymentService.changePaymentMethod(payload);
          case 2:
            _yield$paymentService9 = _context12.v;
            data = _yield$paymentService9.data;
            successMessage = _router.default.app.$t('pages.payment.payment_create_success');
            _helpers.messageHelper.success(successMessage);
            return _context12.a(2, data);
          case 3:
            _context12.p = 3;
            _t12 = _context12.v;
            _helpers.errorResponseHelper.display(_t12);
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x23, _x24) {
      return _ref27.apply(this, arguments);
    };
  }()),
  cancelPlan: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(_ref28, payload) {
      var commit, dispatch, _yield$paymentService0, data, successMessage, _t13;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            commit = _ref28.commit, dispatch = _ref28.dispatch;
            _context13.p = 1;
            _context13.n = 2;
            return _services.paymentService.cancelPlan(payload);
          case 2:
            _yield$paymentService0 = _context13.v;
            data = _yield$paymentService0.data;
            successMessage = _router.default.app.$t('pages.payment.payment_cancel_success');
            _helpers.messageHelper.success(successMessage);
            return _context13.a(2, {
              success: true,
              data: data
            });
          case 3:
            _context13.p = 3;
            _t13 = _context13.v;
            _helpers.errorResponseHelper.display(_t13);
            return _context13.a(2, false);
        }
      }, _callee13, null, [[1, 3]]);
    }));
    return function (_x25, _x26) {
      return _ref29.apply(this, arguments);
    };
  }()),
  updateSignaturePlan: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(_ref30, payload) {
      var commit, rootState, response, successMessage, _t14;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.p = _context14.n) {
          case 0:
            commit = _ref30.commit, rootState = _ref30.rootState;
            _context14.p = 1;
            _context14.n = 2;
            return _services.paymentService.updateSignature(payload);
          case 2:
            response = _context14.v;
            successMessage = _router.default.app.$t('pages.accountManagement.messages.update_plan');
            _helpers.messageHelper.success(successMessage);
            return _context14.a(2, response);
          case 3:
            _context14.p = 3;
            _t14 = _context14.v;
            _helpers.errorResponseHelper.display(_t14);
            return _context14.a(2, false);
        }
      }, _callee14, null, [[1, 3]]);
    }));
    return function (_x27, _x28) {
      return _ref31.apply(this, arguments);
    };
  }()),
  generateNewTicketInvoice: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(_ref32, payload) {
      var commit, rootState, _yield$paymentService1, data, successMessage, _t15;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.p = _context15.n) {
          case 0:
            commit = _ref32.commit, rootState = _ref32.rootState;
            _context15.p = 1;
            _context15.n = 2;
            return _services.paymentService.generateNewTicket(payload);
          case 2:
            _yield$paymentService1 = _context15.v;
            data = _yield$paymentService1.data;
            successMessage = _router.default.app.$t('pages.accountManagement.messages.generate_new_ticket');
            _helpers.messageHelper.success(successMessage);
            return _context15.a(2, data);
          case 3:
            _context15.p = 3;
            _t15 = _context15.v;
            _helpers.errorResponseHelper.display(_t15);
            return _context15.a(2, false);
        }
      }, _callee15, null, [[1, 3]]);
    }));
    return function (_x29, _x30) {
      return _ref33.apply(this, arguments);
    };
  }()),
  fetchDiscount: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(_ref34, payload) {
      var commit, rootState, _yield$paymentService10, data, _t16;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.p = _context16.n) {
          case 0:
            commit = _ref34.commit, rootState = _ref34.rootState;
            _context16.p = 1;
            _context16.n = 2;
            return _services.paymentService.fetchDiscount(payload);
          case 2:
            _yield$paymentService10 = _context16.v;
            data = _yield$paymentService10.data;
            return _context16.a(2, data);
          case 3:
            _context16.p = 3;
            _t16 = _context16.v;
            _helpers.errorResponseHelper.display(_t16);
            return _context16.a(2, false);
        }
      }, _callee16, null, [[1, 3]]);
    }));
    return function (_x31, _x32) {
      return _ref35.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};